import React from 'react';
import { Shield, Lock, FileText, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Confidentialite = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="bg-[#0A192F] text-white py-12 px-4 border-b border-slate-800">
        <div className="container mx-auto max-w-4xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-blue-900 text-blue-200 rounded-xl flex items-center justify-center">
              <Shield className="w-5 h-5" />
            </div>
            <h1 className="text-3xl font-bold">Politique de Confidentialité</h1>
          </div>
          <p className="text-blue-200 text-lg max-w-2xl">
            Transparence, sécurité et respect de vos données personnelles sur Lualaba Services.
          </p>
        </div>
      </div>

      <div className="container mx-auto max-w-4xl px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12 prose prose-slate max-w-none">
          
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r mb-8">
            <p className="text-amber-800 font-medium text-sm m-0">
              <strong>Statut du document :</strong> Lualaba Services est un "Projet proposé". Les présentes règles s'appliquent à la phase de démonstration et pilote. Elles seront validées institutionnellement avant l'exploitation à l'échelle provinciale.
            </p>
          </div>

          <h3 className="flex items-center gap-2 text-xl font-bold text-slate-800 border-b border-slate-100 pb-3 mt-8">
            <FileText className="w-5 h-5 text-blue-600" /> Données collectées
          </h3>
          <p>
            Dans le cadre du traitement de vos demandes d'aide et signalements, nous collectons les informations strictement nécessaires :
          </p>
          <ul>
            <li><strong>Données d'identification :</strong> Nom, prénom, téléphone, adresse e-mail.</li>
            <li><strong>Données de localisation :</strong> Secteur, commune ou adresse précise de l'incident.</li>
            <li><strong>Pièces justificatives :</strong> Fichiers ou photos que vous téléversez volontairement pour appuyer votre demande.</li>
          </ul>

          <h3 className="flex items-center gap-2 text-xl font-bold text-slate-800 border-b border-slate-100 pb-3 mt-8">
            <CheckCircle2 className="w-5 h-5 text-blue-600" /> Finalités et usages
          </h3>
          <p>Vos données sont exclusivement utilisées pour :</p>
          <ul>
            <li>Traiter, qualifier et orienter vos demandes vers les services compétents.</li>
            <li>Vous tenir informé de l'avancement de votre dossier (via la référence unique).</li>
            <li>Produire des statistiques globales et anonymisées pour le Tableau de Bord Gouvernemental (ex: nombre de demandes par territoire).</li>
          </ul>
          <p className="font-semibold text-slate-700">Aucune donnée personnelle n'est revendue ou partagée à des fins commerciales.</p>

          <h3 className="flex items-center gap-2 text-xl font-bold text-slate-800 border-b border-slate-100 pb-3 mt-8">
            <Lock className="w-5 h-5 text-blue-600" /> Accès et sécurité
          </h3>
          <p>
            L'accès à vos informations est strictement encadré :
          </p>
          <ul>
            <li><strong>Agents traitants :</strong> Accès limité aux dossiers de leur file d'attente.</li>
            <li><strong>Direction :</strong> Accès aux indicateurs agrégés sans visibilité sur les données sensibles individuelles.</li>
          </ul>
          <p>
            La plateforme utilise des protocoles sécurisés (HTTPS, chiffrement des mots de passe) et un stockage privé pour les pièces jointes, inaccessible publiquement sans autorisation.
          </p>

          <h3 className="text-xl font-bold text-slate-800 border-b border-slate-100 pb-3 mt-8">
            Réclamations et Droits
          </h3>
          <p>
            Vous avez le droit de demander la consultation, la modification ou la suppression de vos données. Pour toute demande ou réclamation concernant le traitement de votre dossier, vous pouvez contacter l'opérateur technique du projet :
          </p>
          <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 mt-4">
            <p className="font-bold text-slate-800 m-0">Opérateur : GLOTECH DIGITAL</p>
            <p className="text-slate-600 m-0">Email : <a href="mailto:support@lualabaservices.cd" className="text-blue-600 hover:underline">support@lualabaservices.cd</a></p>
            <p className="text-slate-600 m-0">Téléphone : +243 97 123 4567</p>
          </div>

          <div className="mt-12 text-center">
            <Link to="/">
              <Button className="bg-[#0A192F] hover:bg-blue-900 text-white">Retour à l'accueil</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confidentialite;